import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

export function getRegions(countryCode) {
	return Auth.GET(`/Regions/${countryCode}`);
}
export function getUsRegions() {
	return getRegions(`US`);
}